import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, Mail, Clock } from 'lucide-react';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <div className="w-8 h-8 bg-green-600 rounded-lg flex items-center justify-center">
                <Sparkles className="w-5 h-5 text-white" />
              </div>
              <span className="text-xl font-bold">Driscoll Lawn & Land</span>
            </div>
            <p className="text-gray-300 text-sm leading-relaxed">
              Premium landscaping and lawn care services. Transforming properties with professional expertise and attention to detail.
            </p>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">Services</h3>
            <ul className="space-y-3 text-sm">
              <li>
                <span className="text-gray-300 hover:text-green-400 transition-colors duration-200 cursor-pointer">
                  Lawn Applications
                </span>
              </li>
              <li>
                <span className="text-gray-300 hover:text-green-400 transition-colors duration-200 cursor-pointer">
                  Landscape Design
                </span>
              </li>
              <li>
                <span className="text-gray-300 hover:text-green-400 transition-colors duration-200 cursor-pointer">
                  Garden Installation
                </span>
              </li>
              <li>
                <span className="text-gray-300 hover:text-green-400 transition-colors duration-200 cursor-pointer">
                  Property Maintenance
                </span>
              </li>
              <li>
                <span className="text-gray-300 hover:text-green-400 transition-colors duration-200 cursor-pointer">
                  Seasonal Cleanup
                </span>
              </li>
            </ul>
          </div>

         

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">Get in Touch</h3>
            <div className="space-y-3 text-sm">
              <div className="flex items-start space-x-3">
                <Mail className="w-4 h-4 text-green-500 mt-1 flex-shrink-0" />
                <span className="text-gray-300">Driscoll.landscaping80@gmail.com</span>
              </div>
              
              <div className="flex items-start space-x-3">
                <Clock className="w-4 h-4 text-green-500 mt-1 flex-shrink-0" />
                <div className="text-gray-300">
                  <div>Mon-Fri: 8AM-6PM</div>
                  <div>Sat: 9AM-4PM</div>
                </div>
              </div>
            </div>

          </div>
        </div>

        {/* Bottom Border */}
        <div className="border-t border-gray-700 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              &copy; {currentYear} Driscoll Lawn & Land | All rights reserved.
            </p>
            <div className="flex flex-wrap justify-center md:justify-end gap-4 sm:gap-6 text-sm">
              <Link
                to="/contact"
                className="text-gray-400 hover:text-green-400 transition-colors duration-200 py-2 px-1 rounded hover:underline underline-offset-2 focus:outline-none focus:text-green-400"
              >
                Contact
              </Link>
              <Link
                to="/privacy"
                className="text-gray-400 hover:text-green-400 transition-colors duration-200 py-2 px-1 rounded hover:underline underline-offset-2 focus:outline-none focus:text-green-400"
              >
                Privacy Policy
              </Link>
              <Link
                to="/terms"
                className="text-gray-400 hover:text-green-400 transition-colors duration-200 py-2 px-1 rounded hover:underline underline-offset-2 focus:outline-none focus:text-green-400"
              >
                Terms of Service
              </Link>
              <Link
                to="/cookies"
                className="text-gray-400 hover:text-green-400 transition-colors duration-200 py-2 px-1 rounded hover:underline underline-offset-2 focus:outline-none focus:text-green-400"
              >
                Cookie Policy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
